import React, { useState } from 'react'
import { Button, Card, CardBody, CardHeader, Table } from 'reactstrap'
import MultipostDetails from './MultipostDetails'

export default function MonthCard({monthName, shares, basepath, deleteShare}) {
  const sharesByDay = Object.groupBy(shares, (share) => new Date(share.scheduled_at).getDate())

    return (
    <Card className="rounded mb-4">
      <CardHeader>
        <h4 className="m-0">{monthName}</h4>
      </CardHeader>
      <CardBody className="p-0">
        <Table className="mb-0" borderless responsive>
          <tbody>
            {Object.entries(sharesByDay).map(([day, shares]) => {
              return shares.map((share, idx) => (
                <tr key={`share-${share.id}`} className="card-date-row">
                  {idx === 0 && (
                    <td rowSpan={shares.length} className="card-date-column py-3">
                      <h4 className="m-0">{day}</h4>
                      <p className="m-0 text-muted text-uppercase">{share.scheduled_at.toLocaleString('default', { weekday: 'short' })}</p>
                    </td>
                  )}
                  <td className="text-muted py-3 pe-0 column-auto d-none d-md-table-cell align-top">
                    {share.scheduled_at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })}
                  </td>
                  <td>
                    <MultipostDetails share={share} />
                  </td>
                  <td className="table-actions d-none d-md-table-cell align-top">
                    <a href={`${basepath}/${share.id}/edit`} className="btn btn-outline-secondary btn-sm me-2">Edit</a>
                    <Button color="outline-subtle-danger" size="sm" onClick={() => deleteShare(share.id)}>Delete</Button>
                  </td>
                </tr>
              ));
            })}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  )
}